/**
 * Endereços dos dois vizinhos deste site.
 *
 * Este site é ESTÁTICO e não autentica ninguém: tudo que exige sessão (login, cadastro,
 * processo seletivo, plataforma) mora no app. Manter assim é deliberado — se o cadastro
 * acontecesse aqui, o cookie de sessão viraria cross-site e a autenticação da plataforma
 * inteira precisaria de `SameSite=None`, risco alto para ganho nenhum.
 */
export const APP_BASE_URL = import.meta.env.VITE_APP_BASE_URL || "https://app.htstrader.com.br";

/** API pública da plataforma — só rotas liberadas por CORS (Dashboard/server/public-routes.ts). */
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "https://app.htstrader.com.br";

/** Onde o visitante entra na plataforma (a tela de entrada). */
export const URL_ENTRAR = APP_BASE_URL + "/";

/** Onde começa o funil de seleção — é fluxo autenticado, por isso vive no app. */
export const URL_PROCESSO_SELETIVO = APP_BASE_URL + "/processo-seletivo";
